// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mHdwebj_masc_YXEVZgH{width:100%;position:relative;overflow-x:clip}.mHdwebj_masc_YXEVZgH .recharts-wrapper{height:319px!important}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chartContainer": `mHdwebj_masc_YXEVZgH`
};
export default ___CSS_LOADER_EXPORT___;
